<template lang="pug">
  .events-card
    tilt-card(:img="img" :copy="copy" @clicked="onClick")
  
</template>
<script>
import TiltCard from '@/components/home/TiltCard'
import { mapMutations } from 'vuex'
const eventsImg = require('src/assets/events.jpg')
export default {
  name: 'EventsCard',
  components: { TiltCard },
  props: {},
  data() {
    return {
      img: eventsImg,
      copy: {
        cn: '特别活动',
        en: 'Events',
      },
    }
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onClick() {
      this.$router.replace('/events/list')
      this.setRouterBack('/')
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
.events-card
  width: 100%
  height: 100%
</style>
